module.exports = __webpack_public_path__ + "static/media/icon-money.bb34c1ff.svg";